// @ts-ignore
const dummyProduct={name:"Dummy Product"},dummyProductRecord={name:"Dummy Product"},dummyBundleProduct={name:"Dummy Bundle Product"};// @ts-ignore
export{dummyProduct,dummyProductRecord,dummyBundleProduct};